/*global $ */

export function initHomePage() {
  outputNews();
  setPanelMotion();
}

// ニュース出力
function outputNews() {
  // JSON読み込み
  const baseURI = window.location.origin + window.location.pathname;
  const url = baseURI + `wp-content/news.json?${new Date().getTime()}`;
  $.getJSON(url, json => {
    $('#TopNews > .list > .items').html(
      json.news.map(article => {
        return `
        <li class="item${article.is_emphasis ? " -emphasis" : ""}">
          <article class="news">
            <div class="metadata">
              <div class="date">
                <time datetime="${article.date.replace(/\//g, "-")}">${article.date}</time>
              </div>
              <a class="category-tag -${article.category}" href="${document.baseURI}/archives/news_tag/${article.category}">${article.category_name}</a>
              ${ article.divisions.map(division => `<a class="division-tag -${division.division}" href="${document.baseURI}/archives/division_tag/${division.division}">${division.division_name}</a>`).join('') }
              ${ article.warning === "" ? "" : `<span class="applystate -dead">${article.warning}</span>` }
            </div>
            <header>
              <h3 class="title"><a ${article.uri === undefined ? '' : `href="${article.uri}"`} ${!article.target ? '' : `target="${article.target}"`}>${article.title}</a></h3>
            </header>
            ${article.summary ? `<p class="summary">${article.summary}</p>` : ""}
          </article>
          ${article.photo ? `<figure class="photo"><img src="${article.photo}" ${article.alt === undefined ? '' : `alt="${article.alt}"`}></figure>` : ""}
        </li>
        `;
      })
    );
  });

}

function setPanelMotion() {
  const INTERVAL = window.interval;
  const ANNOUNCE_NUM = window.announceNum - 1;
  const panels = [];
  const $topDivisions = $('#TopDivisions');
  let index = 0;
  let increment = 1;
  let timeoutId;

  // bigPanelが存在するかチェック
  const isBigPanel = ((panel) => Object.keys(panel).reduce((acc, key) => {
    return acc *= panel[key].length !== 0;
  }, 1))(window.bigPanel);
  const NUM_OF_PICTURES_USED = 5 + isBigPanel;

  function Panel(key, resources) {
    if (resources.length < 2) return;

    this.key = key;
    this.resources = resources;
    this.queue = this.shuffle();

    // 参照
    this.$elm = $topDivisions.find(`.box > .division.-${key}`);
    this.$resourceArea = $('.resourcearea', this.$elm);
    this.$resourceImage = $('img', this.$resourceArea);
    this.$resourceName = $('.resourcename > .name', this.$resourceArea);
    this.lastResource;
    // プリロード
    for (const resource of this.queue) {
      const img = new Image(240, 240);
      img.src = resource.img;
    }
    // クローン
    this.$fadeArea = $('.resourcearea', this.$elm).clone().addClass('fadearea');
    this.$resourceArea.after(this.$fadeArea);
    this.$fadeImage = $(`img`, this.$fadeArea);
    this.$fadeName = $(`.resourcename > .name`, this.$fadeArea);
    this.$fadeArea.on('transitionend webkitTransitionEnd oTransitionEnd mozTransitionEnd', () => { // クロスフェード終了イベント
      // リソースの表示内容を切り替え
      this.$resourceImage.attr('src', this.$fadeImage.attr('src'));
      this.$resourceName.text(this.$fadeName.text());
      // クローンを非表示に
      this.$fadeArea.removeClass('-fading');
    });
  }
  Panel.prototype.changePicture = function(index) { // リソースの切り替え
    // 現リソースのクローン
    if (!this.$fadeImage) return;
    this.$fadeImage.attr('src', this.queue[index].img);
    this.$fadeName.text(this.queue[index].title);
    this.$fadeArea.addClass('-fading');
  };
  Panel.prototype.shuffle = function() {
    const shuffled1 = [...this.resources];
    const shuffled2 = [];
    do {
      shuffled2.push(...shuffled1.splice(Math.floor(shuffled1.length * Math.random()), 1));
    } while (shuffled1.length > 0);
    const shuffled3 = [];
    do {
      shuffled3.push(...shuffled2);
    } while (shuffled3.length < NUM_OF_PICTURES_USED);
    const rest = shuffled3.splice(NUM_OF_PICTURES_USED);
    if (shuffled3[0] === shuffled3[shuffled3.length - 1]) {
      shuffled3.splice(shuffled3.length - 1, 1, rest[0]);
    }
    return shuffled3;
  }  

   // パネルオブジェクトの生成
    for (const panelKey in window.topDevPanels) {
    panels.push(new Panel(panelKey, window.topDevPanels[panelKey]));
  }

  // 広告用パネルの画像変更
  if (isBigPanel) {
    const divisionBigPanel = document.querySelector('.division.-big');
    divisionBigPanel.href = window.bigPanel.pc[0].uri;
    const pictureTag = divisionBigPanel.querySelector('.announce-picture');
    pictureTag.querySelector('img').src = window.bigPanel.pc[0].img;
    pictureTag.querySelector('source').srcset = window.bigPanel.sp[0].img;
  }

  // コントローラー
  const $controller = $topDivisions.find('.controller');
  $controller.find('.indicators').html(
    [...Array(NUM_OF_PICTURES_USED)].map((_, index) => `<div class="indicator" data-index="${index}"></div>`).join('')
  );
  // 告知用パネルのボタン入れ替え
  if (isBigPanel && ANNOUNCE_NUM !== 5) {
    const panelIndicators = document.querySelectorAll('.indicator');
    panelIndicators[5].setAttribute('data-index', ANNOUNCE_NUM);
    panelIndicators[ANNOUNCE_NUM].setAttribute('data-index', 5);
  }
  $('#TopDivisions').on({ // マウスが領域内の場合はカルーセルを止める
    mouseenter: () => { increment = 0; },
    mouseleave: () => { increment = 1; }
  });
  const $panelIndicators = $controller.find('.indicators > .indicator').each((i, indicator) => {
    indicator.addEventListener('click', () => {
      // 告知用パネルの順番入れ替え
      if (isBigPanel && ANNOUNCE_NUM !== 5) {
        const num = parseInt(indicator.dataset.index);
        switch (num) {
          case ANNOUNCE_NUM:
            changePicture(5);
            break;
          case 5:
            changePicture(ANNOUNCE_NUM);
            break;
          default: 
            changePicture(parseInt(indicator.dataset.index));
        }
      } else {
        changePicture(parseInt(indicator.dataset.index));
      }
    });
  });
  $controller.find('.arrow').each((i, arrow) => {
    arrow.addEventListener('click', () => {
      index += parseInt(arrow.dataset.direction);
      window.clearTimeout(timeoutId);
      changePicture();
    });
  });

  // パネル切り替え
  function changePicture(newIndex = undefined) {
    if (newIndex === undefined) {
      index -= NUM_OF_PICTURES_USED * (index >= NUM_OF_PICTURES_USED);
      index += NUM_OF_PICTURES_USED * (index < 0);
    } else {
      window.clearTimeout(timeoutId);
      index = newIndex;
    }
    for (const panel of panels) {
      panel.changePicture(index);
    }
    for (let i = 0; i < NUM_OF_PICTURES_USED; i++) {
      if (i === index) {
        $panelIndicators[i].classList.add('-current');
      } else {
        $panelIndicators[i].classList.remove('-current');
      }
      if (isBigPanel && index === ANNOUNCE_NUM) {
        $topDivisions.addClass('-showingBigPicture');
      } else {
        $topDivisions.removeClass('-showingBigPicture');
      }
    }
    index += increment;
    timeoutId = window.setTimeout(changePicture, INTERVAL);
  }
  window.requestAnimationFrame(() => {
    changePicture();
  });

}

